import React from "react";
import { Box, Typography, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Button, Chip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const VerifyPaymentOlympiadRegistrationModal = ({ closePopup, modalData }) => {
    const transactions = modalData?.transactions || [];

    const handleVerify = (txn) => {
        console.log("Verify API call for:", txn);
        // 👉 Call your API here
        // verifyTransaction(txn.transactionId)
    };

    return (
        <Box 
  p={2}
  sx={{
    height: "auto",
    backgroundColor: "#fff",
    overflow: "auto"
  }}
>
            <Typography variant="h5" mb={2}>
                Verify Payment Details
            </Typography>

            <IconButton
                onClick={closePopup}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8
                }}
            >
                <CloseIcon />
            </IconButton>

            <table className="table table-bordered table-striped table-sm mb-0" style={{ width: "100%", tableLayout: "auto", whiteSpace: "nowrap" }} >
                <thead className="table table-bordered ">
                    <tr>
                        <th className="text-dark bg-white text-center">S.No</th>
                        <th className="text-dark bg-white text-center">Txn Ref</th>
                        <th className="text-dark bg-white text-center">Total</th>
                        <th className="text-dark bg-white text-center">Paid</th>
                        <th className="text-dark bg-white text-center">Pending</th>
                        <th className="text-dark bg-white text-center">Status</th>
                        <th className="text-dark bg-white text-center">Date</th>
                        <th className="text-dark bg-white text-center">Mode</th>
                        {/* <th className="text-dark bg-white text-center">Attachments</th> */}
                        <th className="text-dark bg-white text-center">Payment Status</th>
                    </tr>
                </thead>
                <tbody>
                    {transactions?.length > 0 ? (
                       transactions?.map((data, index) => (
                            <tr key={data.transactionId} style={{backgroundColor: data?.is_verify == 0 ? "#d6000042" : "#5fff5f62", color:"#000"}}>
                                <td style={{color:"#000", fontWeight:"600"}} className="text-center">{index + 1}</td>
                                <td style={{color:"#000", fontWeight:"600"}} className="text-center">{data.transactionReference}</td>
                                <td style={{color:"#000", fontWeight:"600"}} className="text-center">₹{data.totalAmount}</td>
                                <td style={{color:"#000", fontWeight:"600"}} className="text-center">₹{data.paidAmount}</td>
                                <td style={{color:"#000", fontWeight:"600"}} className="text-center">₹{data.pendingAmount}</td>
                                <td style={{color:"#000", fontWeight:"600"}} className="text-center">{data.transactionStatus}</td>
                                <td style={{color:"#000", fontWeight:"600"}} className="text-center">
                                    {new Date(data.transactionDate).toLocaleString().split(",")[0]}
                                </td>
                                <td style={{color:"#000", fontWeight:"600"}} className="text-center">{data.payment_mode}</td>
                                {/* <td className="text-center">
                                    {data.attachmentName ? "Yes" : "No"}
                                </td> */}
                                <td style={{color:"#000", fontWeight:"600"}} className="text-center">
                                    {data.is_verify == 0 ? (
                                        <span> Pending </span>
                                    ) : (
                                        <span> Done </span>
                                    )}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="11" className="text-center">
                                No Data Found
                            </td>
                        </tr>
                    )}
                </tbody>

            </table>
        </Box>
    );
};

export default VerifyPaymentOlympiadRegistrationModal;